module.exports = __webpack_public_path__ + "img/dealMoney.5a0296dd.png";